import { Check, CircleHelp, Eye, Globe, MoreHorizontal } from "lucide-react";
import { Badge, Button, IconButton, Wordmark } from "../../../components/ui";

type EditorHeaderProps = {
  toolbarRef: (element: HTMLDivElement | null) => void;
  publishing: boolean;
  published: boolean;
  hasUnpublishedChanges: boolean;
  onPreview: () => void;
  onPublish: () => void;
  onPageDetails: () => void;
  onHelp: () => void;
};

export const EditorHeader = ({
  toolbarRef,
  publishing,
  published,
  hasUnpublishedChanges,
  onPreview,
  onPublish,
  onPageDetails,
  onHelp,
}: EditorHeaderProps) => (
  <header className="sticky top-0 z-10 shrink-0 border-b border-hazumu-border bg-hazumu-canvas px-4 py-2 sm:px-5 lg:static lg:bg-hazumu-white lg:py-2.5">
    <div className="mx-auto flex max-w-4xl items-center justify-between gap-2 lg:max-w-none lg:gap-4">
      <div className="flex min-w-0 items-center gap-3">
        <Wordmark size="sm" compact className="lg:hidden" />
        <div ref={toolbarRef} className="editor-document-tools" />
      </div>
      <div className="flex shrink-0 items-center lg:gap-3">
        <IconButton aria-label="Help" title="Help" className="max-lg:size-11" onClick={onHelp}>
          <CircleHelp size={19} />
        </IconButton>
        <IconButton aria-label="Page details" title="Page details" className="max-lg:size-11" onClick={onPageDetails}>
          <MoreHorizontal size={20} />
        </IconButton>
        {/* Phones preview from the quick tools above the navigation. */}
        <Button variant="secondary" size="sm" className="max-lg:hidden" data-tour="preview" onClick={onPreview}>
          <Eye size={14} />
          Preview
        </Button>
        {hasUnpublishedChanges && (
          <Button variant="accent" size="sm" className="max-lg:ml-1" disabled={publishing} onClick={onPublish}>
            <Globe size={14} />
            {publishing ? "Publishing…" : "Publish"}
          </Button>
        )}
        <Badge
          tone={published && !hasUnpublishedChanges ? "success" : "neutral"}
          className="max-lg:hidden"
        >
          {published && !hasUnpublishedChanges && <Check size={12} />}
          {published && !hasUnpublishedChanges ? "Live" : "Draft"}
        </Badge>
      </div>
    </div>
  </header>
);
